import { Alert } from '@elementary/common-ui/components';

const TITLE =
  'Due to Slack rate limits, not all your workspace channels can be listed';
const MESSAGE =
  "If you don't see your channel in the list above, you can still type it manually.";

const ParietalChannelListAlert = () => (
  <Alert severity="info" title={TITLE}>
    {MESSAGE}
  </Alert>
);

export default ParietalChannelListAlert;
